import { ItemType } from '@vista-digital/ocapi-types/v1';
import { getItemById } from '../../../sales-data/selectors/items/get-item-by-id';
import { getDefaultItemPrice } from '../../../sales-data/utils/items/get-default-item-price';
import { createDefaultInProgressNormalItem } from './create-default-in-progress-normal-item';
import { createDefaultInProgressParentSalesItem } from './create-default-in-progress-parent-sales-item';
export const createDefaultInProgressItem = (sellableItem, selectedPrice) => {
    const item = getItemById(sellableItem.itemId);
    if (!item)
        throw new Error(`Cannot find item with ID: ${sellableItem.itemId}.`);
    switch (item.type) {
        case ItemType.Normal:
            return createDefaultInProgressNormalItem(item, selectedPrice || getDefaultItemPrice(sellableItem.prices));
        case ItemType.ParentSales:
            return createDefaultInProgressParentSalesItem(item);
        default:
            throw `Unsupported item type: ${item.type}`;
    }
};
